import type { BlueprintPage } from '../types';

/**
 * Stable identity for a sheet's manual "Additional Notes" — keyed to the panel
 * (or island/countertop) the sheet draws, never the page number. A note stored
 * under this scope follows its panel when islands or pages reorder, and the
 * "Pg. N" reference for it is recomputed live from the panel's current page.
 */
export const getPageNoteScope = (page: BlueprintPage): string => {
	const { panelId, islandId, pageType, customPageId } = page;
	if (customPageId) return `page.${pageType}.${customPageId}`;
	if (panelId) return `panel.${panelId}`;
	if (islandId) return `island.${islandId}.${pageType}`;
	return `page.${pageType}`;
};
